export const QUERY_KEY_SERVICE_ACCOUNTS = 'service-accounts';
export const QUERY_KEY_ACCESS_TOKENS = 'access-tokens';
